import React from 'react';
import { Flex } from '@applyboard/crystal-ui';
import { InfoBoxItemLabel } from "./InfoBoxItemLabel";
import { InfoBoxItemSubLabel } from "./InfoBoxItemSubLabel";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var InfoBoxItem = function InfoBoxItem(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    labelTooltip = _ref.labelTooltip,
    subLabel = _ref.subLabel,
    subLabelLinkUrl = _ref.subLabelLinkUrl;
  return _jsxs(Flex, {
    direction: "column",
    align: "center",
    justify: "center",
    children: [icon && _jsx(Flex.Item, {
      children: icon
    }), _jsx(InfoBoxItemLabel, {
      label: label,
      labelTooltip: labelTooltip
    }), subLabel && _jsx(InfoBoxItemSubLabel, {
      subLabel: subLabel,
      subLabelLinkUrl: subLabelLinkUrl
    })]
  });
};